import {localizeImage} from './images';
import {buildSearchIndex} from '../components/header/searchUtils';
import {localizeStructure, translateText} from './translation';
import {getProductDescription} from './productsTranslation';
import {getServiceDescription} from './servicesTranslation';
import {getKnowledgeData} from './knowledgeTranslation';
import {getNewsTranslation, localizeNews} from './news';

function translateContent(value) {
    if (typeof value === 'string') return translateText(value);
    if (Array.isArray(value)) return value.map(translateContent);
    if (value && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value).map(([key, child]) => [key, translateContent(child)]));
    }
    return value;
}

export function buildLocalizedSearchIndex(structure, products, services, news, content, knowledge, english) {
    if (!english) return buildSearchIndex(structure, products, services, news, content, knowledge);

    const translatedStructure = localizeStructure(structure, true);
    const translatedProducts = {};
    const translatedServices = {};
    function visit(original, translated) {
        Object.entries(original).forEach(([key, node]) => {
            const target = translated[key];
            target.property = translateContent(node.property);
            target.seo = translateContent(node.seo);
            if (node.type === 'product') translatedProducts[target.title] = getProductDescription(node.title, true);
            if (node.type === 'service') translatedServices[key] = getServiceDescription(key, true);
            if (node.links) visit(node.links, target.links);
        });
    }
    visit(structure, translatedStructure);
    const translatedNews = news.map(item => localizeNews(item, true));
    const translatedContent = Object.fromEntries(news.map((item, index) => [
        translatedNews[index].title, getNewsTranslation(item) || content[item.title]
    ]));
    const knowledgeBySlug = new Map(getKnowledgeData(true).articles.map(item => [item.slug, item]));
    const translatedKnowledge = knowledge.map(item => knowledgeBySlug.get(item.slug) || item);
    return buildSearchIndex(translatedStructure, translatedProducts, translatedServices,
        translatedNews, translatedContent, translatedKnowledge).map(item => ({
        ...item,
        image: localizeImage(item.image, true),
        // Keep untranslated sections on their existing routes.
        url: /^\/(production|services|about|lizing|knowledge-base|news)(\/|$)/.test(item.url)
            ? `/en${item.url}` : item.url
    }));
}
